module.exports = __webpack_public_path__ + "img/porsche-992-carrera-s.f84c3d36.jpg";